import { apiClient, type Paginated } from '@/core/api';
import type {
  AcceptInvitationResponse,
  CreateInvitationInput,
  InvitationDto,
  InvitationInspectDto,
  InvitationListParams,
} from './types';

/** `GET /api/invitations/` — admin sees the school's, a teacher only their own. */
export async function getInvitations(
  params: InvitationListParams = {}
): Promise<Paginated<InvitationDto>> {
  const { data } = await apiClient.get<Paginated<InvitationDto>>('/invitations/', { params });
  return data;
}

/** `POST /api/invitations/` — the PRD §4.3 matrix is enforced server-side. */
export async function createInvitation(input: CreateInvitationInput): Promise<InvitationDto> {
  const { data } = await apiClient.post<InvitationDto>('/invitations/', input);
  return data;
}

/** `POST /api/invitations/{public_id}/resend/` — re-emails + extends expiry. */
export async function resendInvitation(publicId: string): Promise<InvitationDto> {
  const { data } = await apiClient.post<InvitationDto>(`/invitations/${publicId}/resend/`);
  return data;
}

/** `POST /api/invitations/{public_id}/revoke/`. */
export async function revokeInvitation(publicId: string): Promise<InvitationDto> {
  const { data } = await apiClient.post<InvitationDto>(`/invitations/${publicId}/revoke/`);
  return data;
}

/** `GET /api/invitations/inspect/?token=` — PUBLIC (throttled): what the invite
 *  token stands for, powering the pre-scoped signup page (PRD §4.2). */
export async function inspectInvitation(token: string): Promise<InvitationInspectDto> {
  const { data } = await apiClient.get<InvitationInspectDto>('/invitations/inspect/', {
    params: { token },
  });
  return data;
}

/** `POST /api/invitations/accept/` — consume a token as an existing user. The
 *  token resolves the school; no X-School header is needed. */
export async function acceptInvitation(token: string): Promise<AcceptInvitationResponse> {
  const { data } = await apiClient.post<AcceptInvitationResponse>('/invitations/accept/', {
    token,
  });
  return data;
}
